import React from 'react';
import { useSelector } from 'react-redux';

function EmployerJobs() {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  return (
    <div className="py-4">
      <h1>Oferty pracy</h1>
      <div className="alert alert-info">
        Zarządzanie ofertami pracy dla: <strong>{userInfo?.company_name}</strong>
      </div>
      <p>Tutaj pojawią się funkcje do tworzenia i zarządzania ofertami pracy</p>
    </div>
  );
}

export default EmployerJobs;
